import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Label, FormGroup, FormFeedback } from 'reactstrap';

import Year from './Year';
import Month from './Month';
import Day from './Day';

import './DatePicker.scss';

class DatePicker extends Component {
  constructor(props) {
    super(props);
    let date = moment(this.props.value);
    let year = 1980;
    let month = null;
    let day = null;
    let dateSelected = false;

    // Prepopulate date with date passed in from prop
    if(date.isValid()) {
      year = parseInt(date.format("YYYY"), 10);
      month = date.format("MMM");
      day = parseInt(date.format("D"), 10);
      dateSelected = true;
    }

    this.state = {
      monthOpen: false,
      dayOpen: false,
      yearOpen: false,
      year: year,
      month: month,
      day: day,
      dateSelected: dateSelected,
      numDays: 31,
      isFocused: false,
      value: this.props.value
    }
    this.toggle = this.toggle.bind(this);
    this.selectMonth = this.selectMonth.bind(this);
    this.selectDay = this.selectDay.bind(this);
    this.selectYear = this.selectYear.bind(this);
    this.backToMonth = this.backToMonth.bind(this);
    this.backToDay = this.backToDay.bind(this);
    this.focusEvent = this.focusEvent.bind(this);
    this.blurEvent = this.blurEvent.bind(this);
    this.selectDate = this.selectDate.bind(this);
  }
  componentDidMount() {
    if(this.props.autoFocus) {
      this.setState({isFocused: true});
    }
  }
  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value && this.props.value !== "Invalid date") {      
      let date = moment(this.props.value);
      let year = 1980;
      let month = null;
      let day = null;
      let dateSelected = false;

      // Prepopulate date with date passed in from prop
      if(date.isValid()) {
        year = parseInt(date.format("YYYY"), 10);
        month = date.format("MMM");
        day = parseInt(date.format("D"), 10);
        dateSelected = true;
      }
      this.setState({
        year: year,
        month: month,
        day: day,
        dateSelected: dateSelected
      });
    }
  }
  toggle(event) {
    if(!this.state.monthOpen && !this.state.dayOpen && !this.state.yearOpen) {
      if(!this.state.dateSelected) {
        this.setState({monthOpen: true});   
      }
      else {
        this.setState({[`${event.target.name}Open`]:true});
      }
    }
    else if(this.state.monthOpen) {
      this.setState({monthOpen: false});  
    }
    else if(this.state.dayOpen){
      this.setState({dayOpen: false});  
    }
    else if(this.state.yearOpen) {
      this.setState({yearOpen: false});  
    }
  }
  backToMonth() {
    if(this.state.dayOpen) {
      this.setState({monthOpen:true, dayOpen: false});  
    }
  }
  backToDay() {
    if(this.state.yearOpen) {
      this.setState({dayOpen:true, yearOpen: false});  
    }
  }
  selectMonth(event) {
    let numDays = moment(event.target.name, "MMM").daysInMonth();

    if(this.state.dateSelected || this.state.year !== null) {
      numDays = moment(`${event.target.name} ${this.state.year}`, "MMM YYYY").daysInMonth();
    }
    else if(event.target.name === "Feb") {
      numDays = 29;
    }
    this.setState({
      month: event.target.name,
      dayOpen: !this.state.dayOpen,
      numDays: numDays
    }, () => {
      this.selectDate();
    });
  }  
  selectDay(event) {
    this.setState({
      day: parseInt(event.target.name, 10),
      yearOpen: !this.state.yearOpen
    }, () => {
      this.selectDate();
    });
  }
  selectYear(event) {
    this.setState({
      dateSelected: true,
      isFocused: false,
      year: parseInt(event.target.name, 10)
    }, () => {      
      this.selectDate();
    });
  }
  selectDate() {
    if(this.state.month !== null && this.state.day !== null && this.state.day !== null) {
      let date = moment(`${this.state.month}-${this.state.day}-${this.state.year}`, "MMM-D-YYYY");

      this.props.onChange({target: {
        name: this.props.name,
        value: date,
        type: "birthdate"
      }});
    }
  }
  focusEvent() {
    this.setState({
      isFocused: true
    });
  }
  blurEvent() {    
    this.setState({
      isFocused: false
    });
  }
  render() {
    return (
      <div className="date-picker">
        <FormGroup>     
          <Label for="month">Month</Label>
          <Label for="day">Day</Label>
          <Label for="year">Year</Label>
          <div className={`date-picker-field ${((this.props.error) ? "error" : "" )} ${((this.state.isFocused && !this.props.error) ? "active" : "" )}`}>
            <Month isOpen={this.state.monthOpen} onFocus={this.focusEvent} onBlur={this.blurEvent} toggle={this.toggle} month={this.state.month} select={this.selectMonth} selected={this.state.dateSelected} autoFocus={this.props.autoFocus} />   
            <Day isOpen={this.state.dayOpen} toggle={this.toggle} day={this.state.day} select={this.selectDay} selected={this.state.dateSelected} numDays={this.state.numDays} month={this.state.month} backToMonth={this.backToMonth} />   
            <Year isOpen={this.state.yearOpen} toggle={this.toggle} year={this.state.year} select={this.selectYear} selected={this.state.dateSelected} day={this.state.day} month={this.state.month} back={this.backToDay} /> 
          </div> 
          <FormFeedback hidden={!this.props.error}>{this.props.errorMessage}</FormFeedback> 
        </FormGroup>
      </div>);
  }
}
DatePicker.defaultProps= {
  onChange: () => {},
  name: "",
  value: "",
  defaultDecade: 1980,
  error: false,
  errorMessage: "" ,
  autoFocus: false
};

DatePicker.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  defaultDecade: PropTypes.number,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  autoFocus: PropTypes.bool
};

export default DatePicker;


// WEBPACK FOOTER //
// ./src/components/DatePicker/DatePicker.js